(function () {
  function syncShopPayVariantInputs(variantId) {
    if (!variantId) return;
    document.querySelectorAll('[data-shop-pay-variant-input]').forEach(function (input) {
      input.value = String(variantId);
    });
  }

  function onVariantDetail(detail) {
    if (!detail || !detail.variant) return;
    syncShopPayVariantInputs(detail.variant.id);
  }

  function bindMainFormSelect() {
    document.querySelectorAll('form.product-single__form:not(.product-single__form--shop-pay)').forEach(function (form) {
      var select = form.querySelector('select[name="id"][data-product-select]');
      if (!select || select.dataset.shopPayBound) return;
      select.dataset.shopPayBound = 'true';
      select.addEventListener('change', function () {
        syncShopPayVariantInputs(select.value);
      });
    });
  }

  function init() {
    bindMainFormSelect();
    document.addEventListener('variant:change', function (evt) {
      onVariantDetail(evt.detail);
    });
    document.addEventListener(
      'variantChange',
      function (evt) {
        onVariantDetail(evt.detail);
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
